import { render } from "./boards.vue?vue&type=template&id=6b9ad0dc&scoped=true"
import script from "./boards.vue?vue&type=script&lang=js"
export * from "./boards.vue?vue&type=script&lang=js"

import "./boards.vue?vue&type=style&index=0&id=6b9ad0dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9ad0dc"]])

export default __exports__